import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-chatting',
    templateUrl: './chatting.component.html',
    styleUrls: ['./chatting.component.scss'],
    standalone: false
})
export class ChattingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
